var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Modifier from 'ember-modifier';
import { action } from '@ember/object';
import MouseSensor from '../sensors/mouse-sensor';
import TouchSensor from '../sensors/touch-sensor';
import { DEFAULT_DRAG_START_DISTANCE } from '../utils/constants';
import { Events } from '../utils/events';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';
import DraggableClone from '../plugins/draggable-clone';
import Autoscroll from '../plugins/autoscroll';
import PreventClick from '../plugins/prevent-click';
import { registerDestructor } from '@ember/destroyable';
let DraggableModifier = (_class = class DraggableModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "flyDragDropManager", _descriptor, this);
    _defineProperty(this, "id", '');
    _defineProperty(this, "isInstalled", false);
    _defineProperty(this, "named", void 0);
    _defineProperty(this, "draggableElement", void 0);
    _defineProperty(this, "initialOffset", {
      x: 0,
      y: 0
    });
    _defineProperty(this, "sensors", []);
    _defineProperty(this, "plugins", []);
    registerDestructor(this, this.cleanup);
  }
  attach() {
    this.id = guidFor(this.draggableElement);
    this.flyDragDropManager.registerDraggable(this);
    this.sensors = [new MouseSensor(this), new TouchSensor(this)];
    this.sensors.forEach(sensor => sensor.attach());
    let plugins = [];
    // TODO: Implement "move" effect
    if (this.named.dragEffect == null || this.named.dragEffect === 'clone') {
      plugins = [...plugins, new DraggableClone(this)];
    }
    if (this.named.autoScrollOnEdges !== false) {
      plugins = [...plugins, new Autoscroll(this)];
    }
    plugins = [...plugins, new PreventClick(this)];
    this.plugins = plugins;
    this.plugins.forEach(plugin => plugin.attach());
    this.draggableElement.dataset.flyDraggable = 'true';
    this.draggableElement.dataset.flyDragDropId = this.id;
    this.draggableElement.addEventListener(Events.BeforeDragStart, this.onBeforeDragStart);
    this.draggableElement.addEventListener(Events.DragStart, this.onDragStart);
    this.draggableElement.addEventListener(Events.DragMove, this.onDragMove);
    this.draggableElement.addEventListener(Events.DragEnd, this.onDragEnd);
  }
  cleanup() {
    this.sensors.forEach(sensor => sensor.detach());
    this.plugins.forEach(plugin => plugin.detach());
    this.draggableElement.removeEventListener(Events.BeforeDragStart, this.onBeforeDragStart);
    this.draggableElement.removeEventListener(Events.DragStart, this.onDragStart);
    this.draggableElement.removeEventListener(Events.DragMove, this.onDragMove);
    this.draggableElement.removeEventListener(Events.DragEnd, this.onDragEnd);
    if (!this.id) {
      return;
    }
    this.flyDragDropManager.unregisterDraggable(this.id);
  }
  get context() {
    return this.named.context ?? {};
  }
  get distance() {
    return this.named.distance ?? DEFAULT_DRAG_START_DISTANCE;
  }
  onBeforeDragStart(event) {
    if (typeof this.named.onBeforeDragStart === 'function') {
      this.named.onBeforeDragStart(event);
    }
  }
  onDragStart(event) {
    this.draggableElement.style.pointerEvents = 'none';
    if (typeof this.named.onDragStart === 'function') {
      this.named.onDragStart(event);
    }
  }
  onDragMove(event) {
    if (typeof this.named.onDragMove === 'function') {
      this.named.onDragMove(event);
    }
  }
  onDragEnd(event) {
    this.draggableElement.style.pointerEvents = '';
    if (typeof this.named.onDragEnd === 'function') {
      this.named.onDragEnd(event);
    }
  }
  modify(element, _positional, named) {
    this.draggableElement = element;
    this.named = named;
    if (!this.isInstalled) {
      this.attach();
      this.isInstalled = true;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flyDragDropManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "cleanup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cleanup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBeforeDragStart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBeforeDragStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragStart", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragMove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragMove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragEnd", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragEnd"), _class.prototype)), _class);
export { DraggableModifier as default };